import * as Yup from "yup";

const emailValidator = Yup.string()
  .trim()
  .email("Please enter a valid email address.");

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email = "") => {
  const value = email.trim();

  return emailValidator.isValidSync(value) && emailRegex.test(value);
};